import { render, staticRenderFns } from "./ChannelAnalyticsDetail.vue?vue&type=template&id=21c64af2&"
import script from "./ChannelAnalyticsDetail.vue?vue&type=script&lang=js&"
export * from "./ChannelAnalyticsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports